/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
export default {
    EXCEPTION_CODE_FORCE_SIGN_OUT: 900,
    EXCEPTION_CODE_FORCE_CHANGE_POS: 901,
    EXCEPTION_CODE_CANNOT_LOGIN: 903,
    EXCEPTION_CODE_SAVED_REQUEST_TO_SERVER: 904,

    STATUS_CODE_UNAUTHORIZED: 401
}



// WEBPACK FOOTER //
// ./src/view/constant/ApiResponseConstant.js